import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import {
    TextField
} from 'mui-rff';
import { numberFormat, amountFormatInput, filterOut } from "../../../utils/utils";
function useRunAfterUpdate() {
    const afterPaintRef = React.useRef(null);
    React.useLayoutEffect(() => {
        if (afterPaintRef.current) {
            afterPaintRef.current();
            afterPaintRef.current = null;
        }
    });
    const runAfterUpdate = fn => (afterPaintRef.current = fn);
    return runAfterUpdate;
}
const AmountInput = (props) => {
    const { onChange } = props;
    const runAfterUpdate = useRunAfterUpdate();
    const onInputChange = (evt) => {
        const input = evt.target;
        const text = input.value;
        const cursor = input.selectionStart;
        const [newValue, newCursor] = filterOut(text, cursor);
        if (typeof window != 'undefined') {

            let defaultValueLength = 0;

            if ("defaultAttribute" in props && evt.target.value == '') {
                defaultValueLength = props.defaultAttribute.length + 1;
            }

            window.requestAnimationFrame(() => {
                input.selectionStart = newCursor + defaultValueLength
                input.selectionEnd = newCursor + defaultValueLength
            })
        }
        evt.target.value = newValue;
        if (typeof onChange === 'function') {
            onChange(evt);
        }
        /*runAfterUpdate(() => {
            input.selectionStart = newCursor;
            input.selectionEnd = newCursor;
        });*/
    }
    return <TextField {...props} onChange={onInputChange} />
};
export default AmountInput;
